<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-body class="pt-50">
        <b-row>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="公司名称" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.companyName"
              class="d-inline-block"
              placeholder="公司名称"
            />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="联系电话" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.contactsPhone"
              class="d-inline-block"
              placeholder="联系电话"
            />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="员工姓名" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.staffName"
              class="d-inline-block"
              placeholder="员工姓名"
            />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="授权手机号" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.userPhone"
              class="d-inline-block"
              placeholder="授权手机"
            />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="客户状态" style="margin-bottom: 0;">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="searchParams.status"
              :options="statusOptions"
              class="w-100"
              :reduce="val => val.value"
            />
            </b-form-group>
          </b-col>

          <b-col class="d-flex justify-content-end">
            <b-button
              v-if="$can('export', 'extension-clueCustomer')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="success"
              class="mt-1"
              @click="exportData"
            >
              导出
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card>
      <b-row class="mb-50">
        <b-col cols="12" md="6" class="mb-md-0 d-flex">
          <b-button-group size="sm">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              @click="visible_coumn = true"
            > 全量 </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :pressed="!visible_coumn"
              @click="visible_coumn = false"
            > 精简 </b-button>
          </b-button-group>
        </b-col>
        <!-- :to="{ name: 'order-new'}" -->
        <!-- <b-col cols="12" md="6" class="mb-md-0 d-flex justify-content-end align-items-end">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary"> 新建经纪人客户 </b-button>
        </b-col> -->
      </b-row>

      <!-- table -->
      <vxe-table
        ref="xTable"
        border
        :column-config="{resizable: true}"
        :auto-resize="true"
        :data="tableData"
        keep-source
        highlight-current-row
        :loading="loading"
        :scroll-x="{enabled: true}"
        :scroll-y="{enabled: true}"
      >
        <vxe-table-column field="companyName" title="公司名称" min-width="230" show-overflow></vxe-table-column>
        <vxe-table-column field="userNickname" title="客户昵称" min-width="120" align="center" show-overflow  :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="userAvatar" title="头像" align="center" width="60" class-name="vxe-table-padding">
          <template v-slot="{ row }">
            <viewer v-if="row.userAvatar">
              <img :src="row.userAvatar" height="35" width="35" class="d-inline-block">
            </viewer>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contacts" title="联系人" align="center" min-width="120"></vxe-table-column>
        <vxe-table-column field="contactsPhone" title="联系电话" width="140" align="center"></vxe-table-column>
        <vxe-table-column field="userPhone" title="授权手机" align="center" width="140"></vxe-table-column>
        <vxe-table-column field="leaseIntention" title="租聘意向" min-width="150" align="center"></vxe-table-column>
        <vxe-table-column field="favorProject" title="意向项目" align="center" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="address" title="客户地址" min-width="250" :visible="visible_coumn" show-overflow></vxe-table-column>
        <vxe-table-column field="industry" title="客户行业" min-width="120"></vxe-table-column>
        <vxe-table-column field="staffName" title="所属员工" width="120" align="center" show-overflow></vxe-table-column>
        <vxe-table-column field="remark" title="备注" min-width="280" align="center" :visible="visible_coumn" show-overflow></vxe-table-column>
        <vxe-table-column field="createdAt" title="转入时间" width="200" align="center"></vxe-table-column>
        <vxe-table-column field="status" title="状态" width="100" align="center" class-name="vxe-table-padding">
          <template v-slot="{ row }">
            <b-badge pill v-if="row.status === '线索'" class="px-1 py-50" variant="light-success"> 线索 </b-badge>
            <b-badge pill v-else-if="row.status === '跟进中'" class="px-1 py-50" variant="light-info"> 跟进中 </b-badge>
            <b-badge pill v-else-if="row.status === '终止'" class="px-1 py-50" variant="light-primary"> 终止 </b-badge>
            <b-badge pill v-else-if="row.status === '签约'" class="px-1 py-50" variant="light-warning"> 签约 </b-badge>
            <b-badge pill v-else-if="row.status === ''" class="px-1 py-50" variant="light-danger"> 未填写 </b-badge>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="d-flex justify-content-between flex-wrap">
        <div class="d-flex align-items-center mb-0 mt-1">
          <Select v-model="searchParams.size" class="mr-1">
            <Option v-for="item in pageOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <span class="text-nowrap"> 共 {{ total }} 条记录 </span>
        </div>
        <div class="d-flex align-items-center">
          <b-pagination v-model="searchParams.page" :total-rows="total" :per-page="searchParams.size" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
          <div class="d-flex align-items-center mb-0 mt-1 ml-1">
            <span class="text-nowrap">跳至</span>
            <Input @on-enter="pageToChange"
              v-model="pageTo" type="number" number class="mx-1" style="width: 5rem;"/>
            <span class="text-nowrap">页</span>
          </div>
        </div>
      </div>
    </b-card>

    <!-- <updateDays v-model="upDays_show" :id="upDays_id" @up-days="upDays" /> -->
  </div>

</template>

<script>
import vSelect from 'vue-select'
import { ref, watch, onMounted, nextTick } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { customerListApi } from '@/api/clueCustomer.js'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// 导出
import { $urlConfig } from '@themeConfig'
import request from '@/auth/jwt/useJwt'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
  },
  setup(props) {
    /* 必要组件加载区域 */

    // 权限组件 弹出确认组件
    // const { $can, $swal } = context.root
    // 消息提醒组件
    const toast = useToast()

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */
    // 表格加载控制 表格数据
    const loading = ref(false)
    const tableData = ref([])
    // 页码选择
    const pageOptions = ref([
      { label: '10 条/页', value: 10 },
      { label: '20 条/页', value: 20 },
      { label: '50 条/页', value: 50 },
    ])
    // 状态条件
    const statusOptions = ref([
      { label: '全部', value: '' },
      { label: '线索', value: '线索' },
      { label: '跟进中', value: '跟进中' },
      { label: '终止', value: '终止' },
      { label: '签约', value: '签约' },
    ])

    // 数量
    const total = ref(0)
    // 控制多余表数据显示否
    const visible_coumn = ref(false)
    // 表格对象DOM
    const xTable = ref(null)
    // 查询条件
    
    const searchParams = ref({
      page: 1, size: 10,
      companyName: '', contactsPhone	: '', staffName: '', userPhone: '', status: '', 
    })
    const pageTo = ref(null)
    // 指定页码操作
    const pageToChange = () => {
      const count = Math.ceil(total.value / searchParams.value.size)
      if (pageTo.value < 1) {
        pageTo.value = 1
      } else if (pageTo.value > count) {
        pageTo.value = count
      } else {
        pageTo.value = parseInt(pageTo.value, 0)
      }
      searchParams.value.page = pageTo.value
    }


    /* 接口调用区域 */
    // 获取列表
    const fetchData = () => {
      customerListApi(searchParams.value)
        .then(res => {
          tableData.value = res.data.list
          total.value = res.data.total
          console.log(res.data.list)
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '获取信息失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }
    
    // 导出
    const exportData = () => {
      toast({
        component: ToastificationContent,
        props: {
          title: '线索客户数据导出',
          text: '正在导出线索客户数据EXCEL文件,请稍等!',
          icon: 'DownloadCloudIcon',
          variant: 'info'
        },
      })

      fetch(
        `${$urlConfig.apiBaseURL}/clue-customer/list?companyName=${searchParams.value.companyName}&contactsPhone=${searchParams.value.contactsPhone}&staffName=${searchParams.value.staffName}&userPhone=${searchParams.value.userPhone}&status=${searchParams.value.status}&isExport=true`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: `${request.jwtConfig.tokenType} ${request.getToken()}`,
          },
          mode: 'cors',
        }
      )
        .then(response => {
          response.blob().then(blob => {
            const link = document.createElement('a')
            link.style.display = 'none'
            // a 标签的 download 属性就是下载下来的文件名
            link.download = `线索客户-${new Date().toLocaleDateString()}.xlsx`
            link.href = URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            // 释放的 URL 对象以及移除 a 标签
            URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          })
        })
    }
   
    // 条件筛选 下拉选择分类 选择项

    /* 组件内部逻辑处理，生命周期问题处理区域 */

    // 处理基本下拉信息加载，权限判断等
    onMounted(() => { fetchData() })

    // 刷新查询
    watch(searchParams.value, () => { fetchData() })

    // 表格数据显示方式
    watch(visible_coumn, () => {
      nextTick(() => { xTable.value.refreshColumn() })
    })

    return {
      loading,
      tableData,
      total,
      xTable,

      pageOptions,
      searchParams,
      pageTo,
      pageToChange,
      statusOptions,

      fetchData,
      exportData,

      visible_coumn,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
